import { AxiosResponse } from "axios";
import { apiClient } from "../constants";
import { Account } from "./types";

const getPath = (userID: string) => `/v1/getUserAccount?userID=${userID}`;

export const getAccount = async (userID: string, sessionToken?: string | null): Promise<Account> => {
  if (!userID) {
    throw new Error("User ID is required");
  }

  const headers: Record<string, string> = {};
  if (sessionToken) {
    headers.Authorization = `Bearer ${sessionToken}`;
  }

  const response: AxiosResponse<Account> = await apiClient.get(getPath(userID), {
    headers
  });

  return response.data;
};
